import { Component, forwardRef, input, Signal, TemplateRef, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoteDataPanelViewBase } from '../remote-data-panel-view.base';
import { LoadingState } from '@softline/core';
import { PanelViewBase } from '@softline/ui-core';
import { RemoteDataContainerComponent } from '../../components/remote-data-container/remote-data-container.component';

@Component({
    selector: 'soft-grid-panel-view',
    imports: [CommonModule, RemoteDataContainerComponent],
    templateUrl: './grid.panel-view.html',
    styleUrl: './grid.panel-view.scss',
    providers: [
        { provide: PanelViewBase, useExisting: forwardRef(() => GridPanelView) },
        { provide: RemoteDataPanelViewBase, useExisting: forwardRef(() => GridPanelView) }
    ]
})
export class GridPanelView<T> extends RemoteDataPanelViewBase<T[]> {
  override name = input.required<string>();
  override label = input<string>('Grid');
  override icon = input<string>('fa-regular fa-grid-2');
  override template = viewChild<TemplateRef<any>>('template');
  override data = input<T[] | null>(null);
  override loadingState = input<LoadingState>(null);
  override loadingError = input<Error | null>(null);
}
